import { Component } from "@angular/core";
import { OrderWizardService } from "../../order/wizard/_service/order-wizard.service";
import { OrderTrackingComponent } from "../../order/tracking/order-tracking.component";
import { OrderPurchaseSummaryComponent } from "../../order/wizard/step-01/summary/order-purchase-summary.component";
import { HttpClient } from "@angular/common/http";
import { SessionUpdateRequest } from "src/app/shared/session/session-update-request.model";

@Component({
    selector: 'print-order-page',
    imports: [OrderPurchaseSummaryComponent],
    templateUrl: './print-order-page.component.html'
})
export class PrintOrderPageComponent {

    constructor(
        public _orderWizardService: OrderWizardService,
        private _httpClient: HttpClient
    ){
    
    }

    ngOnInit(): void {
        this._httpClient.get<SessionUpdateRequest>("api/session/get").subscribe((response) => {
            this._orderWizardService.updateAfterPayment(response.wizardData!);
            //  if(response?.wizardData?.step06){
            //      this.stripePaymentId.set(response.wizardData.step06.stripeId ?? "null");
            //      this.stripeStatus.set(response.wizardData.step06.status ?? "null");
            //  }
         });
    }
}